class InvestmentsController {
    init() {

    }

    index() {
        // Table functionality now handled by modern Stimulus table controller
    }

    edit() {
        investmentsOnEditOrNew();
        
        // Initialize calculations when DOM is ready
        document.addEventListener('DOMContentLoaded', function() {
            syncFormToModel();
            formCalculate();
            syncModelToForm();
        });
        
        // Handle input changes
        document.addEventListener('change', function(event) {
            if (event.target.tagName === 'INPUT') {
                const inputId = event.target.id;
                
                if (['investment_down_payment_percent', 'investment_loan1_pct', 'investment_loan2_pct'].includes(inputId)) {
                    updateAmounts();
                }
                if (['investment_down_payment', 'investment_loan1_amount', 'investment_loan2_amount'].includes(inputId)) {
                    updatePercentages();
                }
                
                syncFormToModel();
                formCalculate();
                syncModelToForm();
                refreshFormats();
                
                const form = event.target.closest('form');
                if (form) {
                    form.submit();
                }
            }
        });
        
        // Handle closing date changes (Native HTML5 date inputs replaced jQuery UI datepicker)
        const closingDateField = document.getElementById('investment_closing_date');
        if (closingDateField) {
            closingDateField.addEventListener('change', function(event) {
                syncFormToModel();
                formCalculate();
                syncModelToForm();
                refreshFormats();
                
                const form = event.target.closest('form');
                if (form) {
                    form.submit();
                }
            });
        }
    }

    new() {
        investmentsOnEditOrNew();
        
        // Handle input changes for new investment
        document.addEventListener('change', function(event) {
            if (event.target.tagName === 'INPUT') {
                syncFormToModel();
                formCalculate();
                syncModelToForm();
            }
        });
    }
}

window.BC = window.BC || {};
window.BC.investments = new InvestmentsController();

function investmentsOnEditOrNew() {
    refreshFormats();
}

function refreshFormats() {
    blurToCurrency(0, [
        '#investment_purchase_price',
        '#investment_down_payment',
        '#investment_loan1_amount',
        '#investment_mortgage_insurance',
        '#investment_loan2_amount',
        '#investment_loan1_MPI',
        '#investment_loan2_MPI',
        '#investment_taxes',
        '#investment_insurance',
        '#investment_total_monthly_payment',
        '#investment_loan1_origination_fee',
        '#investment_loan1_processing_fees',
        '#investment_loan1_misc_fees',
        '#investment_title',
        '#investment_escrow',
        '#investment_loan1_appraisal_fee',
        '#investment_building_basis',
        '#investment_current_value',
        '#investment_initial_improvements',
        '#investment_expense_advertising',
        '#investment_expense_accounting',
        '#investment_expense_water_sewer',
        '#investment_expense_garbage',
        '#investment_expense_electric_gas_oil',
        '#investment_expense_hods',
        '#investment_expense_property_management',
        '#investment_expense_landscaping_maint',
        '#investment_expense_other',
        '#investment_income_rent',
        '#investment_income_other',
        '#investment_income_utility_billback',
        '#investment_income_owner'
    ]);
    blurToPercentage(0, [
        '#investment_down_payment_percent',
        '#investment_loan1_pct',
        '#investment_loan2_pct',
        '#investment_vacancy_rate',
        '#investment_effective_tax_rate'
    ]);
    blurToPercentage(1, [
        '#investment_inflation_rate',
        '#investment_appreciation_rate',
        '#investment_rent_appreciation_rate'
    ]);
    blurToPercentage(3, [
        '#investment_loan1_interest_rate',
        '#investment_loan2_interest_rate'
    ]);
}

// Form input dictionary
let model = {};

// Global input keys for model
const appreciation_rate = 'investment_appreciation_rate';
const rent_appreciation_rate = 'investment_rent_appreciation_rate';
const inflation_rate = 'investment_inflation_rate';
const investment_purchase_price = 'investment_purchase_price';
const down_payment = 'investment_down_payment';
const down_payment_percent = 'investment_down_payment_percent';
const investment_closing_date = 'investment_closing_date';
const loan1_amount = 'investment_loan1_amount';
const loan1_pct = 'investment_loan1_pct';
const loan1_interest_rate = 'investment_loan1_interest_rate';
const loan1_term = 'investment_loan1_term';
const loan2_amount = 'investment_loan2_amount';
const loan2_pct = 'investment_loan2_pct';
const loan2_interest_rate = 'investment_loan2_interest_rate';
const loan2_term = 'investment_loan2_term';
const taxes = 'investment_taxes';
const insurance = 'investment_insurance';
const total_monthly_payment = 'investment_total_monthly_payment';
const loan1_origination_fee = 'investment_loan1_origination_fee';
const loan1_processing_fees = 'investment_loan1_processing_fees';
const loan1_misc_fees = 'investment_loan1_misc_fees';
const title = 'investment_title';
const escrow = 'investment_escrow';
const loan1_appraisal_fee = 'investment_loan1_appraisal_fee';
const interim_interest = 'calc_interim_interest';
const loan1_insurance_premium = 'investment_loan1_insurance_premium';
const income_rent = 'investment_income_rent';
const income_owner = 'investment_income_owner';
const income_other = 'investment_income_other';
const income_utility_billback = 'investment_income_utility_billback';
const vacancy_rate = 'investment_vacancy_rate';
const expense_advertising = 'investment_expense_advertising';
const expense_accounting = 'investment_expense_accounting';
const expense_maintenance = 'investment_expense_maintenance';
const expense_water_sewer = 'investment_expense_water_sewer';
const expense_hods = 'investment_expense_hods';
const expense_garbage = 'investment_expense_garbage';
const expense_electric_gas_oil = 'investment_expense_electric_gas_oil';
const expense_property_management = 'investment_expense_property_management';
const expense_landscaping_maint = 'investment_expense_landscaping_maint';
const expense_other = 'investment_expense_other';
const initial_improvements = 'investment_initial_improvements';
const effective_tax_rate = 'investment_effective_tax_rate';
const building_basis = 'investment_building_basis';
const current_value = 'investment_current_value';

// Global calculated keys for model
const closing_costs = 'calc_closing_costs';
const down_payment_close = 'investment_down_payment_close';
const closing_cost_close = 'investment_closing_cost_close';
const prepaids = 'calc_prepaids';
const total_close = 'investment_total_close';
const loan2_MPI = 'investment_loan2_MPI';
const loan1_MPI = 'investment_loan1_MPI';
const net_rent = 'calc_net_rent';
const annual_income = 'calc_annual_income';
const annual_expenses = 'calc_annual_expenses';
const debt_service = 'calc_debt_service';
const cash_flow = 'calc_cash_flow';
const cash_to_close = 'calc_cash_to_close';
const total_invested = 'calc_total_invested';
const annual_depreciation = 'calc_depreciation';
const profit_loss = 'calc_profit_loss';
const pre_depreciation_profit_loss = 'calc_pre_depreciation_profit_loss';
const taxes_owed = 'calc_taxes_owed';
const after_tax_cash_flow = 'calc_after_tax_cash_flow';
const amortization_table = 'calc_amortization_table';
const amortization_table_2 = 'calc_amortization_table_2';
const five_year_cash_flow = 'calc_five_year_cash_flow';
const five_year_profit_loss = 'calc_five_year_profit_loss';
const five_year_appreciation = 'calc_five_year_appreciation';
const five_year_roi = 'calc_five_year_roi';
const ten_year_cash_flow = 'calc_ten_year_cash_flow';
const ten_year_profit_loss = 'calc_ten_year_profit_loss';
const ten_year_appreciation = 'calc_ten_year_appreciation';
const ten_year_roi = 'calc_ten_year_roi';
const fifteen_year_cash_flow = 'calc_fifteen_year_cash_flow';
const fifteen_year_profit_loss = 'calc_fifteen_year_profit_loss';
const fifteen_year_appreciation = 'calc_fifteen_year_appreciation';
const fifteen_year_roi = 'calc_fifteen_year_roi';
const twenty_year_cash_flow = 'calc_twenty_year_cash_flow';
const twenty_year_profit_loss = 'calc_twenty_year_profit_loss';
const twenty_year_appreciation = 'calc_twenty_year_appreciation';
const twenty_year_roi = 'calc_twenty_year_roi';
const cap_rate = 'calc_cap_rate';
let annual_performance = [];

function updateAmounts() {
    model[loan1_amount] = (model[loan1_pct] || 0) * (model[investment_purchase_price] || 0);
    model[loan2_amount] = (model[loan2_pct] || 0) * (model[investment_purchase_price] || 0);
    model[down_payment] = (model[down_payment_percent] || 0) * (model[investment_purchase_price] || 0);
}

function updatePercentages() {
    // Commented out as in original
    // model[loan1_pct] = (model[loan1_amount] || 0) / (model[investment_purchase_price] || 0);
    // model[loan2_pct] = (model[loan2_amount] || 0) / (model[investment_purchase_price] || 0);
    // model[down_payment_percent] = (model[down_payment] || 0) / (model[investment_purchase_price] || 0);
}

function syncFormToModel() {
    function removeNonNumericalChars(currency) {
        currency = String(currency);
        return Number(currency.replace(/[^\d.-]/g, ''));
    }

    const investmentForm = document.getElementById('investment-form');
    if (investmentForm) {
        const inputs = investmentForm.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            if (input.id) {
                model[input.id] = removeNonNumericalChars(input.value);
            }
        });
    }
}

function syncModelToForm() {
    // Update form input values
    const downPaymentElement = document.getElementById('investment_down_payment');
    if (downPaymentElement) {
        downPaymentElement.value = NumberHelpers.number_to_currency(model[down_payment], {precision: 0});
    }
    
    const loan1AmountElement = document.getElementById('investment_loan1_amount');
    if (loan1AmountElement) {
        loan1AmountElement.value = NumberHelpers.number_to_currency(model[loan1_amount], {precision: 0});
    }
    
    const loan2AmountElement = document.getElementById('investment_loan2_amount');
    if (loan2AmountElement) {
        loan2AmountElement.value = NumberHelpers.number_to_currency(model[loan2_amount], {precision: 0});
    }
    
    const loan1MpiElement = document.getElementById('investment_loan1_MPI');
    if (loan1MpiElement) {
        loan1MpiElement.value = NumberHelpers.number_to_currency(model[loan1_MPI], {precision: 0});
    }
    
    const loan2MpiElement = document.getElementById('investment_loan2_MPI');
    if (loan2MpiElement) {
        loan2MpiElement.value = NumberHelpers.number_to_currency(model[loan2_MPI], {precision: 0});
    }
    
    // Update display elements
    const calcPurchasePrice1 = document.querySelector('#calc_purchase_price_1 span');
    if (calcPurchasePrice1) {
        calcPurchasePrice1.textContent = NumberHelpers.number_to_currency(model[investment_purchase_price], {precision: 0});
    }
    
    const calcDownPayment = document.querySelector('#calc_down_payment span');
    if (calcDownPayment) {
        calcDownPayment.textContent = NumberHelpers.number_to_currency(model[down_payment], {precision: 0});
    }
    
    const calcDownPayment2 = document.querySelector('#calc_down_payment_2 span');
    if (calcDownPayment2) {
        calcDownPayment2.textContent = NumberHelpers.number_to_currency(model[down_payment], {precision: 0});
    }
    
    const calcDownPayment3 = document.querySelector('#calc_down_payment_3 span');
    if (calcDownPayment3) {
        calcDownPayment3.textContent = NumberHelpers.number_to_currency(model[down_payment], {precision: 0});
    }
    
    // Update calculated fields
    updateCalculatedFields();
}

function updateCalculatedFields() {
    // Closing costs calculations
    model[closing_costs] = (model[loan1_origination_fee] || 0) + (model[loan1_processing_fees] || 0) + 
                          (model[loan1_misc_fees] || 0) + (model[title] || 0) + (model[escrow] || 0) + 
                          (model[loan1_appraisal_fee] || 0);
    
    // Cash to close
    model[cash_to_close] = (model[down_payment] || 0) + (model[closing_costs] || 0) + (model[initial_improvements] || 0);
    
    // Annual income
    model[annual_income] = ((model[income_rent] || 0) + (model[income_other] || 0) + 
                           (model[income_utility_billback] || 0) + (model[income_owner] || 0)) * 12;
    
    // Net rent after vacancy
    let gross_rent = (model[income_rent] || 0) + (model[income_other] || 0);
    model[net_rent] = gross_rent * (1 - ((model[vacancy_rate] || 0) / 100));
    
    // Annual expenses
    model[annual_expenses] = ((model[expense_advertising] || 0) + (model[expense_accounting] || 0) + 
                             (model[expense_water_sewer] || 0) + (model[expense_garbage] || 0) + 
                             (model[expense_electric_gas_oil] || 0) + (model[expense_hods] || 0) + 
                             (model[expense_property_management] || 0) + (model[expense_landscaping_maint] || 0) + 
                             (model[expense_other] || 0) + (model[taxes] || 0) + (model[insurance] || 0)) * 12;
    
    // Cash flow
    model[cash_flow] = (model[annual_income] || 0) - (model[annual_expenses] || 0) - (model[total_monthly_payment] || 0) * 12;
    
    // Cap rate
    let noi = (model[annual_income] || 0) - (model[annual_expenses] || 0);
    model[cap_rate] = ((model[investment_purchase_price] || 0) > 0) ? (noi / (model[investment_purchase_price] || 0)) * 100 : 0;
    
    // Update display elements
    const calcClosingCosts = document.querySelector('#calc_closing_costs span');
    if (calcClosingCosts) {
        calcClosingCosts.textContent = NumberHelpers.number_to_currency(model[closing_costs], {precision: 0});
    }
    
    const calcCashToClose = document.querySelector('#calc_cash_to_close span');
    if (calcCashToClose) {
        calcCashToClose.textContent = NumberHelpers.number_to_currency(model[cash_to_close], {precision: 0});
    }
    
    const calcAnnualIncome = document.querySelector('#calc_annual_income span');
    if (calcAnnualIncome) {
        calcAnnualIncome.textContent = NumberHelpers.number_to_currency(model[annual_income], {precision: 0});
    }
    
    const calcAnnualExpenses = document.querySelector('#calc_annual_expenses span');
    if (calcAnnualExpenses) {
        calcAnnualExpenses.textContent = NumberHelpers.number_to_currency(model[annual_expenses], {precision: 0});
    }
    
    const calcCashFlow = document.querySelector('#calc_cash_flow span');
    if (calcCashFlow) {
        calcCashFlow.textContent = NumberHelpers.number_to_currency(model[cash_flow], {precision: 0});
    }
    
    const calcCapRate = document.querySelector('#calc_cap_rate span');
    if (calcCapRate) {
        calcCapRate.textContent = NumberHelpers.number_to_percentage(model[cap_rate], {precision: 2});
    }
    
    const calcNetRent = document.querySelector('#calc_net_rent span');
    if (calcNetRent) {
        calcNetRent.textContent = NumberHelpers.number_to_currency(model[net_rent], {precision: 0});
    }
}

function formCalculate() {
    // Main calculation function that coordinates all calculations
    try {
        // Calculate mortgage payments if we have the required data
        if (model[loan1_amount] && model[loan1_interest_rate] && model[loan1_term]) {
            let mortgage1 = new window.BC.Mortgage.Fixed({
                years: model[loan1_term] || 30,
                price: model[loan1_amount] || 0,
                interest_percent: model[loan1_interest_rate] || 0,
                annual_taxes: model[taxes] || 0,
                annual_insurance: model[insurance] || 0
            });
            model[loan1_MPI] = mortgage1.monthly_payment();
        }
        
        if (model[loan2_amount] && model[loan2_interest_rate] && model[loan2_term]) {
            let mortgage2 = new window.BC.Mortgage.Fixed({
                years: model[loan2_term] || 30,
                price: model[loan2_amount] || 0,
                interest_percent: model[loan2_interest_rate] || 0,
                annual_taxes: 0,
                annual_insurance: 0
            });
            model[loan2_MPI] = mortgage2.monthly_payment();
        }
        
        // Calculate total monthly payment
        model[total_monthly_payment] = (model[loan1_MPI] || 0) + (model[loan2_MPI] || 0);
        
        // Update calculated fields
        updateCalculatedFields();
        
    } catch (error) {
        console.error('Error in formCalculate:', error);
    }
}